// extracted by mini-css-extract-plugin
module.exports = {"clientLogin":"login_clientLogin_1qndj"};